export type GiftCardLookupResult = {
  status?: number
  data?: { remaining_value?: number; type?: string; error?: string }
}

export type GiftCardLookupOutcome = 'success' | 'warning' | 'error' | 'expired'

export const mapGiftCardLookupResponse = ({
  status,
  data,
}: GiftCardLookupResult): GiftCardLookupOutcome => {
  if (status === 200) {
    return data?.remaining_value === 0 ? 'warning' : 'success'
  }
  if (status === 422 && data?.type === 'expired_giftcard') {
    return 'expired'
  }
  return 'error'
}
